var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-lg-row flex-wrap mb-3 mb-lg-0"},[(_vm.possession.form?.itemTypes?.length)?_c('BaseSelect',{staticClass:"col-lg-8 pa-lg-3",attrs:{"name":"itemType","hideDetails":"","rules":{
      required: {
        required: true,
        fieldLabel: 'Item type',
      },
    },"items":_vm.possession.form.itemTypes,"label":!_vm.$vuetify.breakpoint.lgAndUp ? 'Item type' : '',"dense":_vm.$vuetify.breakpoint.lgAndUp},model:{value:(_vm.possession.form.selectedItemType),callback:function ($$v) {_vm.$set(_vm.possession.form, "selectedItemType", $$v)},expression:"possession.form.selectedItemType"}}):_vm._e(),_c('BaseInput',{staticClass:"pa-lg-3",class:[
      _vm.possession.form?.itemTypes?.length
        ? 'order-lg-2 flex-grow-1 col-lg-10'
        : 'flex-grow-1 col-lg-7',
    ],attrs:{"name":"itemDescription","rules":{
      required: {
        required: true,
        fieldLabel: 'Description',
      },
    },"hideDetails":"","placeholder":_vm.$vuetify.breakpoint.lgAndUp
        ? 'Please provide a brief description of the item...'
        : '',"label":!_vm.$vuetify.breakpoint.lgAndUp
        ? _vm.possession.form.descriptionFieldLabel
        : '',"dense":_vm.$vuetify.breakpoint.lgAndUp},model:{value:(_vm.possession.form.descriptionFieldValue),callback:function ($$v) {_vm.$set(_vm.possession.form, "descriptionFieldValue", $$v)},expression:"possession.form.descriptionFieldValue"}}),_c('BaseInput',{staticClass:"pa-lg-3",class:[
      _vm.possession.form?.itemTypes?.length
        ? ' col-lg-4 col-7'
        : 'col-lg-3 col-7',
    ],attrs:{"name":"itemValue","rules":{
      required: {
        required: true,
        fieldLabel: 'Item value',
      },
      regex: {
        required: true,
        fieldLabel: 'Item value',
        pattern: _vm.regexPattern,
        customMessage:
          'Value format is invalid - please enter whole pounds only.',
      },
      min_currency_value: {
        minValue: _vm.possession.form.valueFieldMinValue,
        fieldLabel: 'Item value',
      },
    },"hideDetails":"","label":!_vm.$vuetify.breakpoint.lgAndUp ? _vm.possession.form.valueFieldLabel : '',"minWidth":"200","dense":_vm.$vuetify.breakpoint.lgAndUp,"prefix":"£","validationMode":"lazy","moneyFormat":""},model:{value:(_vm.possession.form.valueFieldValue),callback:function ($$v) {_vm.$set(_vm.possession.form, "valueFieldValue", $$v)},expression:"possession.form.valueFieldValue"}}),_c('div',{staticClass:"d-flex justify-end order-lg-4 col-lg-2 pa-lg-3 align-end"},[_c('BaseButton',{staticClass:"font-weight-bold font-18",attrs:{"depressed":"","name":"add","text":"ADD","rounded":"","height":_vm.$vuetify.breakpoint.lgAndUp ? '40' : '60',"block":"","dense":"","color":'psorange',"type":"submit"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }